import type { Direction } from '@/modules/common/enums/direction.enum.ts';

export class RequestUtil {
  static orderBy(field: string, direction: Direction) {
    return { orderby: `${field} ${direction}` };
  }
}
